import { gql } from '@urql/core';
import React from 'react';
import { ClassOfCardFragment } from '../../../generated/spin-graphql';

type Props = {
    player: ClassOfCardFragment;
};

gql`
    fragment ClassOfCard on espin_player_profile {
        graduating_class
    }
`;

export const ClassOfCard: React.FC<Props> = ({ player }) => {
    return (
        <div className="profile-card dark-theme">
            <div className="title-container">
                <h2 className="title">Class Of</h2>
            </div>
            <p className="value class">{player.graduating_class}</p>
        </div>
    );
};
